export default __webpack_public_path__ + "static/media/Bjorn_NW.a66a4027.png";